import api from '../../utils/api'

export const state = {
  calculationMemorials: []
}

export const mutations = {
  SET_CALCULATION_MEMORIALS(state, calculationMemorials) {
    state.calculationMemorials = calculationMemorials
  }
}

export const actions = {
  async handleCreate(_, filesDescriptionMethodology) {
    try {
      return await api.post('/files-description-methodology', filesDescriptionMethodology)
    } catch (err) {

    }
  },

  async handleUpdade(_, filesDescriptionMethodology) {
    try {
      return await api.put(`/files-description-methodology/${filesDescriptionMethodology._id}`, filesDescriptionMethodology)
    } catch (err) {

    }
  },

  async handleGet(_, id) {
    try {
      const { data } = await api.get(`/files-description-methodology/${id}`)
      const { filesDescriptionMethodology } = data
      return filesDescriptionMethodology
    } catch (err) {

    }
  },

  async handleGetCalculationMemorials({ commit }) {
    try {
      const { data: dataCalculationMemorials } = await api.get(`/files-description-methodology/calculation-memorials`)
      const { calculationMemorials } = dataCalculationMemorials
      commit('SET_CALCULATION_MEMORIALS', calculationMemorials);
    } catch (err) {

    }
  },

  async handleGetAll({ commit }, params) {
    try {
      const { data } = await api.get(`/files-description-methodology`, { params })
      const { filesDescriptionMethodology } = data

      const { data: dataCalculationMemorials } = await api.post(`/files-description-methodology/calculation-memorials`)
      const { calculationMemorials } = dataCalculationMemorials
      commit('SET_CALCULATION_MEMORIALS', calculationMemorials);

      return filesDescriptionMethodology
    } catch (err) {
      console.error('err')
      console.error(err)
      console.error('err')
    }
  },

  async handleDelete(_, id) {
    try {
      return await api.delete(`/files-description-methodology/${id}`)
    } catch (err) {

    }
  }

}

export const getters = {
  getCalculationMemorials: (state) => state.calculationMemorials,
}
